import { Component, Inject, Input } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: "app-call-phone-dialog",
  templateUrl: "./call-phone-dialog.component.html",
  styleUrls: ["./call-phone-dialog.component.scss"],
  standalone: true,
  imports: [MatIconModule],
})
export class CallToPhoneDialogComponent {
  title?: string;
  subtitle?: string;
  confirmButton?: string;
  cancelButton?: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any = {},
    private dialogRef: MatDialogRef<CallToPhoneDialogComponent>
  ) {
    this.title = data?.title ?? "Are you sure you want to leave?";
    this.subtitle = data?.subtitle ?? "You have unsaved changes";
    this.confirmButton = data?.confirmButton ?? "Yes, I want to leave";
    this.cancelButton = data?.cancelButton ?? "No, I want to stay";
  }

  close() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close(this.data?.id ?? true);
  }
}
